// extracted by mini-css-extract-plugin
export default {"modal":"RefreshBNBModalButton_modal__3dyLH","paper":"RefreshBNBModalButton_paper__o0Ha2","heading":"RefreshBNBModalButton_heading__2AhB6"};